module.exports = "/_next/static/images/c911f9a5c3b6962e77d471fce075a20c-guy-lg.jpg.webp";